import React from 'react';
import { Link } from 'react-router-dom';
import Hero from '../../components/Hero';
import { hvacProducts } from '../../data/hvacProducts';
import './ProductList.css';

const ProductList: React.FC = () => {
  return (
    <div className="product-list">
      <Hero
        title="TCL Heat Pump Systems"
        subtitle="High-efficiency mini-splits, ducted systems, and multi-zone solutions for every application."
        background="gradient-dark"
        fullHeight={false}
      />

      <section className="section section--dark">
        <div className="container">
          <div className="product-list__grid">
            {hvacProducts.map((product) => (
              <Link
                key={product.id}
                to={`/products/${product.id}`}
                className="product-list__card"
              >
                <div className="product-list__card-visual">
                  <img src={product.image} alt={product.name} className="product-list__card-img" />
                </div>
                <span className="product-list__card-category">{product.category}</span>
                <h3 className="product-list__card-name">{product.name}</h3>
                <p className="product-list__card-tagline">{product.tagline}</p>
                <div className="product-list__card-highlights">
                  {product.highlights.slice(0, 3).map((h) => (
                    <div key={h.label} className="product-list__card-highlight">
                      <span className="product-list__card-highlight-value">{h.value}</span>
                      <span className="product-list__card-highlight-label">{h.label}</span>
                    </div>
                  ))}
                </div>
                <span className="product-list__card-cta">
                  View Details
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <line x1="5" y1="12" x2="19" y2="12" />
                    <polyline points="12 5 19 12 12 19" />
                  </svg>
                </span>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default ProductList;
